import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-gerenciamento',
  imports: [RouterOutlet],
  templateUrl: './gerenciamento.html',
  styleUrl: './gerenciamento.scss',
})
export class Gerenciamento {}
